import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import { Tooltip } from '@yme/atoms/tooltip';
import { useWindowSize } from '@yme/common/hooks';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { PropertyStyled } from './styled';
const ATTRIBUTES_AMOUNT = 2;
export function ProductProperties({ properties, hasPadding = true }) {
    const { isInfiniteDesktopView } = useWindowSize();
    const values = Object.entries(omitBy(properties, isEmpty));
    const elements = isInfiniteDesktopView ? values.slice(0, ATTRIBUTES_AMOUNT) : values;
    const remainingElements = values.length > ATTRIBUTES_AMOUNT ? `+${values.length - ATTRIBUTES_AMOUNT}` : '';
    const TooltipTitle = (React.createElement(React.Fragment, null, values.slice(ATTRIBUTES_AMOUNT).map(([key, value]) => (React.createElement(Fragment, { key: key },
        `${key}: ${value}`,
        React.createElement("br", null))))));
    return (React.createElement(RegularTextLevel4, { color: colorCoreBlack300 },
        elements.map(([key, value]) => (React.createElement(Tooltip, { title: `${key}: ${value}`, key: value, hasEnableHoverListener: isInfiniteDesktopView },
            React.createElement(PropertyStyled, { hasPadding: hasPadding }, value)))),
        isInfiniteDesktopView && remainingElements && (React.createElement(Tooltip, { title: TooltipTitle, hasEnableHoverListener: isInfiniteDesktopView },
            React.createElement("span", null, remainingElements)))));
}
